export interface Video {
  id: number;
  title: string;
  duration: string;
  bunnyNetVideoId?: string;
  posterUrl?: string;
}

export interface Module {
  id: number;
  title: string;
  description: string;
  videos: Video[];
  availableFrom: string; // ISO date string
}

export const MODULES: Module[] = [
  {
    id: 1,
    title: "The Mindset You Need to Succeed",
    description: "What top performers believe and how they think. We'll cover habits, confidence, and how to deal with pressure.",
    availableFrom: "2025-10-09T00:00:00+07:00", // Thursday, 9 October 2025 00:00 WIB
    videos: [
      {
        id: 1,
        title: "Welcome to Shaun Dju Academy",
        duration: "03:19",
        bunnyNetVideoId: "71aac682-00a5-4ecf-8c10-aa03904764a8"
      },
      {
        id: 2,
        title: "Asking Why?",
        duration: "02:35",
        bunnyNetVideoId: "675443b6-6d0a-423a-89ac-c07e7cec0e3b"
      },
      {
        id: 3,
        title: "Rule #1: Life isn't Fair",
        duration: "02:49",
        bunnyNetVideoId: "22435e36-26de-472b-bfdf-74c3a6016de8"
      },
      {
        id: 4,
        title: "Rule #2: Mutually Beneficial",
        duration: "02:08",
        bunnyNetVideoId: "5896be29-c9e3-4e15-b3bc-04862877a970"
      },
      {
        id: 5,
        title: "Rule #3: Being Right vs Being Helpful",
        duration: "02:13",
        bunnyNetVideoId: "679c0db8-a62d-4590-83d1-7ade29021b80"
      },
      {
        id: 6,
        title: "Rule #4: Focus on What you can Control",
        duration: "02:36",
        bunnyNetVideoId: "8c1b4faa-1c19-48ee-afd0-56bd78bc8faa"
      },
      {
        id: 7,
        title: "Rule #5: Unforced Errors",
        duration: "02:40",
        bunnyNetVideoId: "83eeaa83-2a62-43af-8579-e18c083eec90"
      },
      {
        id: 8,
        title: "Rule #6: T-shaped Skills",
        duration: "02:00",
        bunnyNetVideoId: "b32af818-382e-4171-9d3c-6b04edb553c4"
      },
      {
        id: 9,
        title: "Rule #7: That's not my Job",
        duration: "01:36",
        bunnyNetVideoId: "0b26fd0a-4be6-4509-ae09-da3e9c7b4349"
      },
      {
        id: 10,
        title: "Rule #8: Under Promise, Over Deliver",
        duration: "02:16",
        bunnyNetVideoId: "dd22a3a8-2e2e-47e0-a096-32ade70201a7"
      },
      {
        id: 11,
        title: "Mental Bola",
        duration: "01:42",
        bunnyNetVideoId: "d10b807a-e325-4ac6-b021-4d106d05f046"
      },
      {
        id: 12,
        title: "Characters of Corporate Superstars",
        duration: "01:56",
        bunnyNetVideoId: "22ef5ae9-2ca4-4492-bf63-2c0619db5b49"
      },
      {
        id: 13,
        title: "They Hate Us Coz They Ain't Us",
        duration: "03:08",
        bunnyNetVideoId: "1f4bc951-7649-414f-9cbc-3e6a01979b74"
      },
      {
        id: 14,
        title: "Module 1 Homework",
        duration: "01:44",
        bunnyNetVideoId: "74843bf0-4bdc-4df8-8633-1456278b3c14"
      }
    ]
  },
  {
    id: 2,
    title: "Smooth Sailing Networking",
    description: "Step-by-step guide on how to get interviews and impress every interviewer—from outreach to final round.",
    availableFrom: "2025-10-09T00:00:00+07:00", // Thursday, 9 October 2025 00:00 WIB
    videos: [
      {
        id: 1,
        title: "Introduction to Module 2",
        duration: "00:43",
        bunnyNetVideoId: "ab2d64ec-3aef-4954-a51a-93f23183cf9e"
      },
      {
        id: 2,
        title: "Getting Jobs is a Networking Process",
        duration: "01:29",
        bunnyNetVideoId: "f20355b2-0cb8-44f7-922b-89885786e3c9"
      },
      {
        id: 3,
        title: "Maximizing Visibility",
        duration: "02:02",
        bunnyNetVideoId: "3baef0c5-9d32-44cf-b57b-aa7944a126be"
      },
      {
        id: 4,
        title: "Why NOT ATS?",
        duration: "01:29",
        bunnyNetVideoId: "46de87e7-2a20-4e15-8053-0d52cb4355c5"
      },
      {
        id: 5,
        title: "Interview Gameshark",
        duration: "01:40",
        bunnyNetVideoId: "eaf0e196-c10a-4d20-8d79-34a9fa6a5827"
      },
      {
        id: 6,
        title: "Just Getting Coffee? Really?",
        duration: "02:42",
        bunnyNetVideoId: "ee58259a-daf2-4e82-b416-567aec5a436b"
      },
      {
        id: 7,
        title: "Control the Interview Flow",
        duration: "01:22",
        bunnyNetVideoId: "1db1df39-8429-4d86-9197-51a097b09bf0"
      },
      {
        id: 8,
        title: "Mix and Match",
        duration: "02:15",
        bunnyNetVideoId: "d54773d0-5887-4a55-8e36-89522f506719"
      },
      {
        id: 9,
        title: "Case Interviews are Getting Common",
        duration: "01:25",
        bunnyNetVideoId: "b40fed6d-ba83-4ae5-80be-cba29d1316af"
      },
      {
        id: 10,
        title: "Stair Structure",
        duration: "02:58",
        bunnyNetVideoId: "d53eb6fd-7f01-4bae-9fec-f6997ab081a2"
      },
      {
        id: 11,
        title: "Profitability Tree",
        duration: "01:00",
        bunnyNetVideoId: "9f9add5d-2d6b-403a-a3d0-e1a9d9c0baf0"
      },
      {
        id: 12,
        title: "Business Situation Framework",
        duration: "01:15",
        bunnyNetVideoId: "afaa28c7-43eb-43cb-b0db-619fd8ebb914"
      },
      {
        id: 13,
        title: "Case Interview Flow",
        duration: "01:31",
        bunnyNetVideoId: "29abc65b-c779-4c7e-bccf-d515af64b319"
      },
      {
        id: 14,
        title: "Farming Cases and Practicing Interviews",
        duration: "01:42",
        bunnyNetVideoId: "87f3b7cb-354d-445b-91ad-4ac4e08172e8"
      },
      {
        id: 15,
        title: "What's Your Best Offer?",
        duration: "01:50",
        bunnyNetVideoId: "05963d67-47f4-4a6c-8998-bee3f664372e"
      },
      {
        id: 16,
        title: "Module 2 Homework",
        duration: "01:36",
        bunnyNetVideoId: "5f05e376-3073-4d22-93bc-e38e75d2f4ec"
      }
    ]
  },
  {
    id: 3,
    title: "Excel & PPT Wizardry",
    description: "What to master and why. With the goal of working as effectively and efficiently as possible.",
    availableFrom: "2025-10-09T00:00:00+07:00", // Thursday, 9 October 2025 00:00 WIB
    videos: [
      {
        id: 1,
        title: "Introduction to Module 3",
        duration: "00:47",
        bunnyNetVideoId: "d2e350fb-595f-461d-ae0b-a2d633af13b6"
      },
      {
        id: 2,
        title: "Benefits of Being a Wizard",
        duration: "01:28",
        bunnyNetVideoId: "d66bb555-8949-41b4-ab90-3b269d921eb1"
      },
      {
        id: 3,
        title: "Becoming Insanely Fast",
        duration: "01:56",
        bunnyNetVideoId: "85fc0277-04ec-4803-8d1c-797fa4d45740"
      },
      {
        id: 4,
        title: "Quick Access Toolbar",
        duration: "01:39",
        bunnyNetVideoId: "de423383-d0b9-4a66-898a-59e440caf4e6"
      },
      {
        id: 5,
        title: "Shortcut Cheat Sheet",
        duration: "00:52",
        bunnyNetVideoId: "85287ab3-3efb-4138-92fd-d291b54a7dd8"
      },
      {
        id: 6,
        title: "Absolute vs Relative References (Locking)",
        duration: "03:53",
        bunnyNetVideoId: "64f42491-a277-4cb1-b0e9-973d78e373ff"
      },
      {
        id: 7,
        title: "Arithmetic Formulas (Part 1)",
        duration: "04:24",
        bunnyNetVideoId: "5163bf8e-06be-418e-b832-29c5a9c8051f"
      },
      {
        id: 8,
        title: "Arithmetic Formulas (Part 2)",
        duration: "02:02",
        bunnyNetVideoId: "526715a7-9c6f-496b-80ea-c78e47a7a1eb"
      },
      {
        id: 9,
        title: "Arithmetic Formulas (Part 3)",
        duration: "01:35",
        bunnyNetVideoId: "bbbf3887-863f-4efc-8e81-1be491dda2e9"
      },
      {
        id: 10,
        title: "Introduction to Index Match",
        duration: "04:12",
        bunnyNetVideoId: "fdc46562-29af-4050-b2a2-95c490f06f75"
      },
      {
        id: 11,
        title: "Using Index Match",
        duration: "02:19",
        bunnyNetVideoId: "9080e70f-f883-44e7-997e-059092913f49"
      },
      {
        id: 12,
        title: "Index Match Match Power",
        duration: "02:49",
        bunnyNetVideoId: "040cc2a6-07c4-44b0-95b9-4436f7019853"
      },
      {
        id: 13,
        title: "Indirect References",
        duration: "05:01",
        bunnyNetVideoId: "191d39b3-ba6f-401d-8a44-7ed654419beb"
      },
      {
        id: 14,
        title: "Goal Seek",
        duration: "02:01",
        bunnyNetVideoId: "3b6d8ccd-e8bd-4b97-ae1e-8f4074f7b36d"
      },
      {
        id: 15,
        title: "Data Validation",
        duration: "01:14",
        bunnyNetVideoId: "8577a9bd-d89f-4c3c-9700-245eb48d9255"
      },
      {
        id: 16,
        title: "Multi-Level Sorting",
        duration: "01:05",
        bunnyNetVideoId: "bb7e90d4-805b-4bcd-8f56-c52e231224dd"
      },
      {
        id: 17,
        title: "Text to Columns",
        duration: "01:09",
        bunnyNetVideoId: "baad4d95-b90c-4e5a-9a68-b8454569f791"
      },
      {
        id: 18,
        title: "Purpose of a Slide",
        duration: "01:10",
        bunnyNetVideoId: "70b9faa5-d80f-4b01-b3c9-46703926f6df"
      },
      {
        id: 19,
        title: "Tailor-made Decks",
        duration: "01:06",
        bunnyNetVideoId: "48d8a89d-88ca-4eac-8aa9-30cfc2e4aa23"
      },
      {
        id: 20,
        title: "How to Accomplish Meeting Goals",
        duration: "01:30",
        bunnyNetVideoId: "f8c6ce29-0a9e-4b48-bcbe-4d272154b365"
      },
      {
        id: 21,
        title: "Vertical Logic",
        duration: "01:11",
        bunnyNetVideoId: "7ac297c2-97ad-4ba7-a89a-cbd6e5c82395"
      },
      {
        id: 22,
        title: "Slide Messaging Format",
        duration: "01:01",
        bunnyNetVideoId: "95f5a965-f289-411a-98ab-d7ca32093a2d"
      },
      {
        id: 23,
        title: "Different Slide Structures",
        duration: "04:56",
        bunnyNetVideoId: "466a5089-52ba-42ec-b9d2-2200bf76f0d1"
      },
      {
        id: 24,
        title: "Chart Visualizations",
        duration: "02:19",
        bunnyNetVideoId: "ab3a8754-96ae-4306-be71-38f29556ee30"
      },
      {
        id: 25,
        title: "Pay Attention to Whitespaces",
        duration: "01:37",
        bunnyNetVideoId: "eb499f48-fcb4-4d18-a5d8-96d434cfdc38"
      },
      {
        id: 26,
        title: "Use Colors only to Direct Attention",
        duration: "01:13",
        bunnyNetVideoId: "3c9c257c-d511-4c1c-a053-10a3202a7f1a"
      },
      {
        id: 27,
        title: "Module 3 Homework",
        duration: "01:51",
        bunnyNetVideoId: "4a8ad9fb-3293-44bf-89fa-18c7ef2b5d2b"
      }
    ]
  },
  {
    id: 4,
    title: "Crystal Clear Communication",
    description: "How to write sharp email reports, speak up in meetings, and present your ideas confidently.",
    availableFrom: "2025-10-09T00:00:00+07:00", // Thursday, 9 October 2025 00:00 WIB
    videos: [
      {
        id: 1,
        title: "Introduction to Module 4",
        duration: "00:50",
        bunnyNetVideoId: "a9c1535d-4587-4b07-a12b-e2e80898042a"
      },
      {
        id: 2,
        title: "Indonesia's Clear Communication Framework",
        duration: "01:43",
        bunnyNetVideoId: "43ec1903-9878-463c-904d-857e8687b9f5"
      },
      {
        id: 3,
        title: "Written and Oral Communication Structure",
        duration: "01:18",
        bunnyNetVideoId: "cedfeb4e-4459-45a7-a0e9-12f80c3ac1e7"
      },
      {
        id: 4,
        title: "Typing Speed Hack",
        duration: "01:34",
        bunnyNetVideoId: "64cfc604-77e6-4ba3-8f6c-915a86c88688"
      },
      {
        id: 5,
        title: "Never Miss a Note",
        duration: "02:41",
        bunnyNetVideoId: "bb3c4ed9-e7b8-4638-b38a-8e243c2ae048"
      },
      {
        id: 6,
        title: "Sharp Email using S.P.A.R.K.",
        duration: "02:07",
        bunnyNetVideoId: "e8ac4cea-c520-4c88-99b5-c7d16512a48f"
      },
      {
        id: 7,
        title: "Art of Storyboarding",
        duration: "01:55",
        bunnyNetVideoId: "91d0d0ac-ca5f-4495-9ebf-5b7eb5a4c71b"
      },
      {
        id: 8,
        title: "How to Speak Up in Meetings",
        duration: "02:38",
        bunnyNetVideoId: "df10cdcc-cd09-4fec-96df-07e779819f46"
      },
      {
        id: 9,
        title: "Command a Presentation",
        duration: "01:32",
        bunnyNetVideoId: "c302df1e-454d-41b9-9746-fbff3f9f179a"
      },
      {
        id: 10,
        title: "Smooth Feedback",
        duration: "01:51",
        bunnyNetVideoId: "783c1b47-7074-4908-a75b-29efe08f7059"
      },
      {
        id: 11,
        title: "Typing Speed Benchmark",
        duration: "02:35",
        bunnyNetVideoId: "f097856b-9929-49a1-a307-32fa60bb0de8"
      },
      {
        id: 12,
        title: "Revising Emails (part 1)",
        duration: "02:34",
        bunnyNetVideoId: "fb0d778e-4eea-4a4d-a38c-95887a26c95c"
      },
      {
        id: 13,
        title: "Revising Emails (part 2)",
        duration: "02:09",
        bunnyNetVideoId: "7fdd6563-4a6b-40e0-981c-2ab18cd23ec6"
      },
      {
        id: 14,
        title: "Revising Emails (part 3)",
        duration: "02:09",
        bunnyNetVideoId: "c4a9b656-974e-4275-8746-753ed674d4a4"
      },
      {
        id: 15,
        title: "Revising Emails (part 4)",
        duration: "01:48",
        bunnyNetVideoId: "0d7834f4-ec0c-4b40-b4e2-cf978df03c39"
      },
      {
        id: 16,
        title: "Revising Emails (part 5)",
        duration: "01:42",
        bunnyNetVideoId: "eb1f82a7-4719-4074-bb3b-157c27e1c54b"
      },
      {
        id: 17,
        title: "Module 4 Homework",
        duration: "02:15",
        bunnyNetVideoId: "05f96712-5aa7-47f8-b074-1d871417a642"
      }
    ]
  },
  {
    id: 5,
    title: "Managing Projects and People aka Get Promoted",
    description: "Learn how to organize and run projects, including managing perception to your bosses for maximum visibility and get promoted.",
    availableFrom: "2025-10-09T00:00:00+07:00", // Thursday, 9 October 2025 00:00 WIB
    videos: [
      {
        id: 1,
        title: "Introduction to Module 5",
        duration: "01:39",
        bunnyNetVideoId: "38819156-cb1d-44b1-8834-4cd88f4ed917"
      },
      {
        id: 2,
        title: "Governance - Meeting Cadences",
        duration: "01:36",
        bunnyNetVideoId: "57ad3b19-9969-4345-9afb-14f013f801cf"
      },
      {
        id: 3,
        title: "Governance - Project Updates",
        duration: "01:32",
        bunnyNetVideoId: "51d781bd-08df-4989-ad3b-fe1fa3d1cbea"
      },
      {
        id: 4,
        title: "Governance - Follow Up Culture",
        duration: "02:11",
        bunnyNetVideoId: "0923ed6a-4ecf-43a7-b8ed-d039c62c8e23"
      },
      {
        id: 5,
        title: "Accountability - Ownership",
        duration: "02:16",
        bunnyNetVideoId: "6c7f66dc-5001-45e6-b782-cacd99a35524"
      },
      {
        id: 6,
        title: "Accountability - RACI Matrix",
        duration: "01:53",
        bunnyNetVideoId: "8862d9bf-5dd9-42fa-9c63-ff6fb07f0a26"
      },
      {
        id: 7,
        title: "Accountability - OKRs and KPIs",
        duration: "02:44",
        bunnyNetVideoId: "1d4eabe5-f284-4bbf-8ce9-105b2497801a"
      },
      {
        id: 8,
        title: "Feedback Loop - Iterations and Refinements",
        duration: "01:17",
        bunnyNetVideoId: "d185c4d9-91bb-4e56-bbea-d70c66049217"
      },
      {
        id: 9,
        title: "Feedback Loop - Timeliness",
        duration: "02:24",
        bunnyNetVideoId: "d4161ee0-07cb-44e3-be53-b0a319e8b555"
      },
      {
        id: 10,
        title: "Feedback Loop - Actions",
        duration: "01:25",
        bunnyNetVideoId: "adaef59a-adde-4bcd-8c0a-441160275f2b"
      },
      {
        id: 11,
        title: "Tools - Kanban Board",
        duration: "01:33",
        bunnyNetVideoId: "ddff1c3f-48d1-4fb1-9802-bdce005c5c2d"
      },
      {
        id: 12,
        title: "Tools - Praktek",
        duration: "01:53",
        bunnyNetVideoId: "785908ca-5896-44e2-be3f-0e8f33430b77"
      },
      {
        id: 13,
        title: "Stakeholder Management - Mapping",
        duration: "01:40",
        bunnyNetVideoId: "5fc37d70-9714-4deb-8c7e-5e90a09baca4"
      },
      {
        id: 14,
        title: "Stakeholder Management - Escalation",
        duration: "01:47",
        bunnyNetVideoId: "87014994-6427-4601-a8ae-f67654f35ab1"
      },
      {
        id: 15,
        title: "People Management Framework",
        duration: "01:19",
        bunnyNetVideoId: "99b9c94e-a55c-41ae-b3c3-54fe4024cdd4"
      },
      {
        id: 16,
        title: "Look the Part, Take yourself Seriously",
        duration: "02:36",
        bunnyNetVideoId: "ad26107f-4b56-4aa5-b3d4-654f0400f624"
      },
      {
        id: 17,
        title: "Explore Interests Outside of Work",
        duration: "02:07",
        bunnyNetVideoId: "87809f58-5c6e-45eb-bbbd-bf5b9d163627"
      },
      {
        id: 18,
        title: "Seek Out New Experiences",
        duration: "02:50",
        bunnyNetVideoId: "3f082c4f-da0d-4fb9-9471-47cb8da18c16"
      },
      {
        id: 19,
        title: "Spend Time Outside of Work",
        duration: "01:42",
        bunnyNetVideoId: "7bfbe2d2-2885-4925-b27a-44d98f3503f9"
      },
      {
        id: 20,
        title: "Start Convos and Be Fast Resp",
        duration: "02:26",
        bunnyNetVideoId: "83d3115e-3281-44e2-8a14-38c2a8c0aaff"
      },
      {
        id: 21,
        title: "Show Genuine Care",
        duration: "02:11",
        bunnyNetVideoId: "82223e61-e9a2-4528-b3d6-4271e0b648bd"
      },
      {
        id: 22,
        title: "Managing Bosses",
        duration: "02:05",
        bunnyNetVideoId: "64b67628-f9fa-491d-8039-6e270ad33166"
      },
      {
        id: 23,
        title: "Managing Juniors",
        duration: "01:49",
        bunnyNetVideoId: "27db0649-40e1-415b-bb5c-7ae5d41ea08a"
      },
      {
        id: 24,
        title: "Managing Cross-Function Peers",
        duration: "01:47",
        bunnyNetVideoId: "0a21b49a-a36b-485b-81de-7fc1119c4052"
      },
      {
        id: 25,
        title: "Managing External Perception",
        duration: "02:23",
        bunnyNetVideoId: "f903646b-8ec6-428f-b8ea-fb8cf180a8c8"
      },
      {
        id: 26,
        title: "Module 5 Homework",
        duration: "01:50",
        bunnyNetVideoId: "46f682d2-127a-4e8d-a84b-f315b6ddfa2c"
      }
      // Add more videos for module 5 as needed
    ]
  }
];

// Helper function to calculate total module duration
export const getTotalModuleDuration = (videos: Video[]) => {
  const totalMinutes = videos.reduce((total, video) => {
    const [minutes, seconds] = video.duration.split(':').map(Number);
    return total + minutes + seconds / 60;
  }, 0);
  
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);
  
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};

// Helper function to check if a module is available based on current date
export const isModuleAvailable = (module: Module): boolean => {
  const now = new Date();
  const availableDate = new Date(module.availableFrom);
  return now >= availableDate;
};

// Helper function to get available modules based on access level and current date
export const getAvailableModulesByDate = (accessLevel: string, userBatch?: number): Module[] => {
  const availableModules = MODULES.filter(module => {
    // First check if user has access to this module based on their level
    let hasAccess = false;
    switch (accessLevel) {
      case 'Uni':
        hasAccess = module.id <= 2;
        break;
      case 'First':
        hasAccess = module.id <= 4;
        break;
      case 'Manager':
        hasAccess = module.id <= 5;
        break;
      default:
        hasAccess = false;
    }
    
    // If no access level, return false
    if (!hasAccess) {
      return false;
    }
    
    // Previous batches (1-8) have lifetime access - bypass date restrictions
    if (userBatch !== undefined && userBatch <= 10) {
      return true;
    }
    
    // Current batch (9) follows scheduled release
    return isModuleAvailable(module);
  });
  
  return availableModules;
};

// Helper function to get module availability status
export const getModuleAvailabilityStatus = (module: Module, userBatch?: number) => {
  // Previous batches (1-8) have lifetime access - bypass date restrictions
  if (userBatch !== undefined && userBatch <= 10) {
    return {
      status: 'available',
      label: 'Available',
      color: 'bg-green-100 text-green-800'
    };
  }

  const now = new Date();
  const availableDate = new Date(module.availableFrom);
  
  if (now >= availableDate) {
    return {
      status: 'available',
      label: 'Available',
      color: 'bg-green-100 text-green-800'
    };
  } else {
    const timeUntilAvailable = availableDate.getTime() - now.getTime();
    const daysUntilAvailable = Math.ceil(timeUntilAvailable / (1000 * 60 * 60 * 24));
    
    return {
      status: 'locked',
      label: `Available in ${daysUntilAvailable} days`,
      color: 'bg-gray-100 text-gray-800'
    };
  }
}; 